module.exports = __webpack_public_path__ + "img/welcome-frame.a0de71ba.svg";